<!-- <header class="preloader-header" *ngIf="scancomplete === true">
  <h1 class="preloader-header__title">Scanning Complete</h1>
</header> -->
<div class="center-align vertical-align-middle" *ngIf="scancomplete === true">
  <div>
    <h1 style="visibility: hidden;">{{scanItem.value}}</h1>
    <a #goto style="visibility: hidden;" class="btn" id="goto" (click)="close($event)" [href]="gotoLink" target="_blank" color="primary">Resume work in app</a>
  </div>
</div>
